import { render, staticRenderFns } from "./article-image.vue?vue&type=template&id=8265a578&scoped=true&"
import script from "./article-image.vue?vue&type=script&lang=js&"
export * from "./article-image.vue?vue&type=script&lang=js&"
import style0 from "./article-image.vue?vue&type=style&index=0&id=8265a578&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../tmp/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8265a578",
  null
  
)

export default component.exports